module.exports = __webpack_public_path__ + "img/invoice.f0f4a7c9.svg";